import { useSyncExternalStore } from "react";

/**
 * SSR-safe media query hook using useSyncExternalStore.
 * Returns true if the media query matches.
 */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (callback) => {
      const mql = window.matchMedia(query);
      mql.addEventListener("change", callback);
      return () => mql.removeEventListener("change", callback);
    },
    () => window.matchMedia(query).matches,
    () => false,
  );
}
